<template>
  <q-page padding class=" column ">
    <div class="col-1">
      <h4 class="q-ma-xs">Организации</h4>
    </div>
    <div class="col-11 row">
      <div class="col-12">
        <div class="column q-gutter-y-md ">
          <div class="col-1 row">
            <q-space/>
            <q-btn color="primary" label="Создать" class="q-ma-xs" @click="newOrganization = true"/>
            <q-dialog v-model="newOrganization" persistent>
              <new-organization-form @add="addOrganization" @cancel="newOrganization = false"/>
            </q-dialog>
          </div>
<!--          <div class="col-1">
            <q-input v-model="search" filled dense/>
          </div>-->
          <div class="col-10">
            <organization-table ref="organizationTable" :search="searchTable"/>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {useDebounce} from "@vueuse/core";
import {useProjectTypesStore} from "../store/projectTypes";
import {storeToRefs} from "pinia";
import ProjectsTable from "../components/ProjectsTable.vue";
import NewProjectTypeForm from "../components/NewProjectTypeForm.vue";
import {ProjectType} from "../models/project";
import NewProjectForm from "../components/NewProjectForm.vue";
import OrganizationTable from "../components/OrganizationTable.vue";
import NewOrganizationForm from "../components/NewOrganizationForm.vue";

const search = ref("")
const searchTable = useDebounce(search, 500)

const organizationTable = ref()

const newOrganization = ref(false)

function addOrganization() {
  organizationTable.value.fetch()
  newOrganization.value = false
}
</script>

<style scoped>

</style>